// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__VhWac","tab":"ProcedureTabs_tab__3aCi8"};